<template>
  <div class="widget-group" :data-field="templateObject.widget_id" :id="templateObject.widget_id">
    <div class="widget-header">
      <h3 class="float-left">{{ templateObject.properties.title }}</h3>
      <button @click="addRow" class="btn btn-sm btn-success float-right btnAddRow">Add</button>
    </div>
    <div>
      <h4>{{ messageWidget }}</h4>
    </div>
    <div class="tableWidget">
      <table class="table table-sm table-bordered table-striped" v-show="tableView">
        <thead>
          <tr>
            <th v-for="(column, key) in templateData.columns" :key="key" :data-fieldname="column.fieldName">{{ column.title }}</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fieldObject, fieldObjectKey) in templateData.fields" :key="fieldObjectKey" :data-objectkey="fieldObjectKey">
            <td v-for="(column, columnKey) in templateData.columns" :key="columnKey" :data-fieldname="column.fieldName">
              <template v-for="(field, fieldKey) in fieldObject">
                <template v-if="column.fieldName === field.fieldName">
                  <combo-widget v-if="column.type === 'combobox'"
                    :ref="fieldObjectKey+','+fieldKey"
                    :fieldIndex="fieldObjectKey+','+fieldKey"
                    :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                    :key="fieldKey"
                    :fieldName="field.fieldName"
                    :options="column.values"
                    :editable="field.editable"
                    :autoWidth=true
                    :readOnly=true>
                    </combo-widget>
                  <text-widget v-else-if="column.type === 'text'"
                    :ref="fieldObjectKey+','+fieldKey"
                    :fieldIndex="fieldObjectKey+','+fieldKey"
                    :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                    :key="fieldKey"
                    :fieldName="field.fieldName"
                    :editable="field.editable"
                    :autoWidth=true
                    :readOnly=true>
                    </text-widget>
                  <checkbox-widget v-else-if="field.type === 'checkbox'"
                    :ref="fieldObjectKey+','+fieldKey"
                    :fieldIndex="fieldObjectKey+','+fieldKey"
                    :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                    :key="fieldKey"
                    :fieldName="field.fieldName"
                    :editable="field.editable"
                    :autoWidth=true
                    :readOnly=true>
                    </checkbox-widget>
                </template>
              </template>
            </td>
            <td data-priority="-100" class="box-actions">
              <button class="btn btn-info" v-if="showHiddenMessage" href="#" @click="editWidget(fieldObjectKey)">Edit/Show</button>
              <button class="btn btn-info" v-else href="#" @click="editWidget(fieldObjectKey)">Edit</button>
              <button class="btn btn-danger" href="#" @click="deleteRow(fieldObjectKey)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showHiddenMessage">
      <p style="color:#777;">Some fields are not visible due to your resolution</p>
    </div>

    <div style="margin-bottom:15px;" v-show="!tableView">
      <section v-if="templateData.fields.length === 0" style="box-shadow: 1px 1px 2px 2px black; padding:5px;" v-for="(column, key) in templateData.columns" :key="key" :data-fieldname="column.fieldName">{{ column.title }}</section>

      <div class="widget-box" v-for="(fieldObject, fieldObjectKey) in templateData.fields" :key="fieldObjectKey">
        <div class="widget-input" v-for="(field, fieldKey) in fieldObject" :key="fieldKey">
          <span class="widget-label">{{ field.title }}:</span>
          <combo-widget v-if="field.type === 'combobox'"
            :ref="fieldObjectKey+','+fieldKey"
            :fieldIndex="fieldObjectKey+','+fieldKey"
            :initialValue="field.newValue.length ? field.newValue : field.originalValue"
            :key="fieldKey"
            :fieldName="field.fieldName"
            :options="field.values"
            :editable="field.editable"
            :readOnly=true>
            </combo-widget>
          <text-widget v-else-if="field.type === 'text'"
            :ref="fieldObjectKey+','+fieldKey"
            :fieldIndex="fieldObjectKey+','+fieldKey"
            :initialValue="field.newValue.length ? field.newValue : field.originalValue"
            :key="fieldKey"
            :fieldName="field.fieldName"
            :editable="field.editable"
            :readOnly=true>
            </text-widget>
          <checkbox-widget v-else-if="field.type === 'checkbox'"
            :ref="fieldObjectKey+','+fieldKey"
            :fieldIndex="fieldObjectKey+','+fieldKey"
            :initialValue="field.newValue.length ? field.newValue : field.originalValue"
            :key="fieldKey"
            :fieldName="field.fieldName"
            :editable="field.editable"
            :readOnly=true>
            </checkbox-widget>
        </div>
        <button class="widget-box-edit btn btn-info" href="#" @click="editWidget(fieldObjectKey)">Edit</button>
        <button class="btn btn-danger" @click="deleteRow(fieldObjectKey)">Delete</button>
      </div>
    </div>

    <group-edit-modal ref="editModal"></group-edit-modal>
  </div>
</template>

<script>
import GroupEditModal from '@/components/questionnaires/widget-group/GroupEditModal'
import ComboWidget from '@/components/questionnaires/widgets/ComboWidget'
import TextWidget from '@/components/questionnaires/widgets/TextWidget'
import CheckboxWidget from '@/components/questionnaires/widgets/CheckboxWidget'

export default {
  name: 'widget-group',

  components: {
    GroupEditModal,
    ComboWidget,
    TextWidget,
    CheckboxWidget
  },

  data () {
    return {
      tableView: true,
      columnPriorities: {},
      hiddenColumns: {},
      previousClientSize: -1,
      newRowObject: [],
      currentLowestPriority: 100,

      hotfixInterval: null,
      hotfixCount: 0,
      templateData: {},
      messageWidget: ''
    }
  },

  computed: {
    showHiddenMessage: function () {
      return this.tableView && Object.keys(this.hiddenColumns).length > 0
    }
  },

  props: {
    fieldModel: {
      type: String
    },
    fieldIndex: {
      type: String,
      required: true
    },
    templateObject: {
      type: Object,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  mounted () {
    this.$store.state.widgets.forEach((widget, index) => {
      this.$store.state.widgets[index]['model'].forEach(model => {
        if (model === this.fieldModel) {
          let widgetData = JSON.parse(JSON.stringify(this.$store.state.questionnaires[this.$store.state.currentTemplateName]['properties']['widgetData']))
          Object.keys(widgetData).forEach(widgetId => {
            if (widget.fieldName === widgetId) {
              this.messageWidget = widgetData[widgetId].message
            }
          })
        }
      })
    })
    if (typeof this.templateObject.newValue === 'object' && Object.keys(this.templateObject.newValue).length) {
      this.templateData = this.templateObject.newValue
    } else this.templateData = this.templateObject.originalValue

    this.setupData()

    this.windowResized()
    window.addEventListener('resize', this.windowResized)

    let that = this
    this.$on('widgetChanged', data => {
      that.widgetChanged(data)
    })

    this.$bus.on('msgWidget', (dataWidget) => {
      if (dataWidget.model === this.fieldModel) that.messageWidget = dataWidget.message
    })

    this.$on('saveEdit', function (data) {
      that.saveEdit(data)
    })
  },

  methods: {
    setupData () {
      this.templateData.columns.forEach(column => {
        this.columnPriorities[column.priority] = column.fieldName
      })

      let newFields = []
      for (let index = 0; index < this.templateData.fields.length; index++) {
        const fieldObject = this.templateData.fields[index]
        let newFieldObject = []
        this.templateData.columns.forEach(column => {
          fieldObject.forEach(field => {
            if (column.fieldName === field.fieldName) {
              field['type'] = column.type
              field['values'] = column.values
              field['title'] = column.title
              field['desc'] = column.desc
              newFieldObject.push(field)
            }
          })
        })
        newFields.push(newFieldObject)
      }

      if (newFields.length) {
        this.newRowObject = JSON.parse(JSON.stringify(newFields[0]))
        this.newRowObject.forEach(field => {
          field.newValue = ''
          field.originalValue = ''
        })
      } else {
        let newRowObject = []
        this.templateData.columns.forEach(column => {
          let newRow = {
            approved: false,
            deleted: false,
            desc: column.desc,
            editable: true,
            fieldName: column.fieldName,
            itemId: null,
            model: '',
            newValue: '',
            originalValue: '',
            state: 'OK',
            title: column.title,
            type: column.type,
            values: column.values
          }
          newRowObject.push(newRow)
        })
        this.newRowObject = newRowObject
      }
      let temp = this.templateData
      // window.Vue.set(temp, 'fields', newFields)
      this.templateData = temp

      this.sortRows()
    },

    updateWidget () {
      const apiUrl = this.$store.state.apiUrl
      const requestData = {
        widgetId: this.templateObject.widget_id,
        newData: this.templateData
      }
      let that = this
      this.axios.post(apiUrl + 'widget/update', requestData).then(response => {
        if (response.data.success) that.$store.commit('updateWidget', requestData)
        else {
          this.$bus.emit('addNotification', {
            title: 'Widget Update Error',
            body: 'There was an error updating the widget. Please reload the page and try again',
            type: 'error'
          })
        }
      })
    },

    saveEdit (data) {
      let tmp = JSON.parse(JSON.stringify(this.templateData))
      let tmpFields = tmp.fields
      tmpFields[data.index] = data.fields
      tmp.fields = tmpFields
      window.Vue.set(this, 'templateData', tmp)
      for (let index = 0; index < data.fields.length; index++) {
        const field = data.fields[index]
        if (!field.newValue.length) continue
        let refIndex = data.index + ',' + index
        this.$refs[refIndex][0].$emit('setValue', field.newValue)
      }
      this.sortRows()
      // this.updateWidget()
      this.windowResized()
      this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.templateData})
    },

    sortRows () {
      let rowUnsortedFields = {}
      for (let rowIndex = 0; rowIndex < this.templateData.fields.length; rowIndex++) {
        const row = this.templateData.fields[rowIndex]
        row.forEach(field => {
          if (field.fieldName !== this.templateObject.properties.sortedBy.column) return

          let value = field.newValue.toLowerCase()
          if (!value.length) value = field.originalValue.toLowerCase()

          if (typeof rowUnsortedFields[value] !== 'undefined') rowUnsortedFields[value + '_' + Date.now()] = rowIndex
          else rowUnsortedFields[value] = rowIndex
        })
      }

      let sortedList = Object.keys(rowUnsortedFields).sort()
      if (!this.templateObject.properties.sortedBy.asc) sortedList = sortedList.reverse()

      let newFields = []
      sortedList.forEach(fieldName => {
        const nextRowIndex = rowUnsortedFields[fieldName]
        newFields.push(this.templateData.fields[nextRowIndex])
      })

      // window.Vue.set(this.templateData, 'fields', newFields)
      this.updateDisplay()
      this.toggleColumns()

      window.dispatchEvent(new Event('resize'))
      let that = this
      this.hotfixInterval = window.setInterval(() => {
        window.dispatchEvent(new Event('resize'))
        that.hotfixCount++
        if (that.hotfixCount >= 10) window.clearInterval(that.hotfixInterval)
      }, 10)
    },

    widgetChanged (data) {
      const index = data.index.split(',')
      let fields = this.templateData.fields
      fields[index[0]][index[1]]['newValue'] = data.value
      // window.Vue.set(this.templateObject, 'fields', fields)
      // this.updateWidget()
      // this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.templateData})
    },

    windowResized () {
      const container = this.$el
      if (container.clientWidth <= 580) {
        this.tableView = false
        return
      }

      this.tableView = true
      this.toggleColumns()
    },

    addRow () {
      let tmp = this.templateData
      tmp.fields.push(JSON.parse(JSON.stringify(this.newRowObject)))
      this.templateData = tmp
      let that = this
      setTimeout(() => {
        that.hideAfterAdd()
      }, 100)
      this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.templateData})
    },

    hideAfterAdd () {
      const tableRows = document.getElementsByTagName('tr')
      const lastRow = tableRows[tableRows.length - 1]

      this.editWidget(lastRow.getAttribute('data-objectkey'))

      const dataColumns = lastRow.getElementsByTagName('td')
      for (const column of dataColumns) {
        const fieldname = column.getAttribute('data-fieldname')
        if (fieldname === null || !fieldname.length) continue
        if (Object.values(this.hiddenColumns).indexOf(fieldname) !== -1) {
          column.classList.add('hidden')
        }
      }
    },

    deleteRow (index) {
      window.swal({
        title: 'Delete Row?',
        text: 'Are you sure you want to delete this row from ' + this.templateObject.properties.title + '?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((deleted) => {
        if (deleted) {
          window.Vue.delete(this.templateData.fields, index)
          this.updateDisplay()
          // this.updateWidget()
          this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.templateData})
        }
      })
    },

    updateDisplay () {
      for (let rowIndex = 0; rowIndex < this.templateData.fields.length; rowIndex++) {
        const fieldRow = this.templateData.fields[rowIndex]
        for (let fieldIndex = 0; fieldIndex < fieldRow.length; fieldIndex++) {
          const field = fieldRow[fieldIndex]
          let value = field.newValue
          if (!value.length) value = field.originalValue
          const refIndex = rowIndex + ',' + fieldIndex
          if (typeof this.$refs[refIndex] !== 'undefined') {
            this.$refs[refIndex][0].$emit('setValue', value)
          }
        }
      }
    },

    toggleColumns () {
      const container = this.$el

      let tableRows = document.getElementsByTagName('tr')
      if (tableRows.length <= 1) return
      const topRow = tableRows[1]
      const rowRect = topRow.getBoundingClientRect()

      if (container.clientWidth < rowRect.width) {
        const hiddenOffset = rowRect.width - container.clientWidth
        const offsetWidth = rowRect.width - hiddenOffset

        const dataColumns = topRow.getElementsByTagName('td')
        if (dataColumns[dataColumns.length - 1] === undefined) return
        const lastColRect = dataColumns[dataColumns.length - 1].getBoundingClientRect()

        if (lastColRect.left + lastColRect.width > offsetWidth) {
          // const amountOffscreen = (lastColRect.left + lastColRect.width) - offsetWidth
          const lowestIndex = Object.keys(this.columnPriorities).sort().pop()
          if (lowestIndex === undefined) return
          const lowestPriority = this.columnPriorities[lowestIndex]
          const lowestElems = document.querySelectorAll('[data-fieldname="' + lowestPriority + '"]')
          this.currentLowestPriority = lowestIndex - 1
          for (const elem of lowestElems) {
            elem.classList.add('hidden')
          }
          window.Vue.set(this.hiddenColumns, lowestIndex.toString(), this.columnPriorities[lowestIndex])
          window.Vue.delete(this.columnPriorities, lowestIndex)
        }
      }

      if (Object.keys(this.hiddenColumns) && container.clientWidth > this.previousClientSize) {
        const highestIndex = Object.keys(this.hiddenColumns).sort().reverse().pop()
        const highestPriority = this.hiddenColumns[highestIndex]
        const highestElems = document.querySelectorAll('[data-fieldname="' + highestPriority + '"]')
        for (const elem of highestElems) {
          elem.classList.remove('hidden')
        }
        window.Vue.set(this.columnPriorities, highestIndex, this.hiddenColumns[highestIndex])
        window.Vue.delete(this.hiddenColumns, highestIndex)
        this.previousClientSize = container.clientWidth
        this.toggleColumns()
      }

      this.previousClientSize = container.clientWidth
    },

    editWidget (index) {
      if (this.templateData.fields[index] === undefined) return
      let fieldData = JSON.parse(JSON.stringify(this.templateData.fields[index]))

      fieldData.forEach(field => {
        this.templateData.columns.forEach(column => {
          if (field.fieldName === column.fieldName) {
            field['type'] = column.type
            field['values'] = column.values
            field['title'] = column.title
          }
        })
      })

      this.$refs.editModal.$emit('showModal', {
        index: index,
        fields: fieldData
      })
    }
  },

  beforeDestroy () {
    this.$off('widgetChanged')
    this.$bus.$off('msgWidget')
    this.$off('saveEdit')
  }
}
</script>

<style lang="scss" scoped>
  
  .tableWidget {
    margin-bottom: 15px;
    overflow-x: auto;
  }

  .widget-header {
    display: inline-block;
    width: 100%;
    padding: 2px;
  }

  .hidden {
    display: none;
  }

  .widget {
    display: inline;
  }

  .widget-input {
    margin: 5px 0 5px 0;
  }

  .widget-box {
    margin: 10px 5px 10px 5px;
    border: 2px solid black;
    padding: 10px;
  }

  .widget-label {
    font-weight: bold;
  }

  .widget-box-edit {
    margin: 10px;
  }

  th {
    text-align: center;
  }

  td div {
    display: inline-block;
  }

  .box-actions a {
    display: block;
    text-align: center;
  }

  .btnAddRow {
    margin-top: 20px;
  }

  .table-widget {
    overflow-x: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/widget-group/WidgetGroup.vue